import React, { useEffect } from 'react';

const BuyWithPrimeWidget = ({ sku }) => {
  useEffect(() => {
    // 1. Remove any existing BWP script if already appended
    const existingScript = document.querySelector('script[src="https://code.buywithprime.amazon.com/bwp.v1.js"]');
    if (existingScript) {
      existingScript.remove();
    }

    // 2. Create and append the BWP script
    const loadBwpScript = document.createElement('script');
    loadBwpScript.setAttribute('fetchpriority', 'high');
    loadBwpScript.async = true;
    loadBwpScript.src = 'https://code.buywithprime.amazon.com/bwp.v1.js'; // Use exact URL from merchant console
    document.head.appendChild(loadBwpScript);

    // 3. When the script loads, run updateWidget
    loadBwpScript.onload = () => {
      if (window.bwp && typeof window.bwp.updateWidget === 'function') {
        window.bwp.updateWidget(sku);
      }
    };

    // 4. Cleanup on unmount
    return () => {
      loadBwpScript.remove();
    };
  }, [sku]); // Re-run when `sku` changes

  return (
    <div
    id="amzn-buy-now"
    data-site-id="8chlcznvx9"
    data-widget-id="w-eBKEkAAfBm330FAemKJH21"
    data-sku={sku}
  ></div>
  );
};

export default BuyWithPrimeWidget;
